import { render } from "./CIS-Accordion-With-Image.vue?vue&type=template&id=770bd948"
import script from "./CIS-Accordion-With-Image.vue?vue&type=script&lang=js"
export * from "./CIS-Accordion-With-Image.vue?vue&type=script&lang=js"

import "./CIS-Accordion-With-Image.vue?vue&type=style&index=0&id=770bd948&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__